/* eslint-disable no-unused-vars */
/* eslint-disable class-methods-use-this */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/prefer-default-export */
// services/auth0Service.js
import { createAuth0Client } from "@auth0/auth0-spa-js";
import {  REACT_APP_AUTH0_AUDIENCE, REACT_APP_AUTH0_DOMAIN } from "../vars";
import { getAuth0Options } from "../utils/util";

console.log(REACT_APP_AUTH0_DOMAIN);

class Auth0Service {
    #clientPromise = null;

	async getClient(modOption) {
	if (!this.#clientPromise || modOption) this.#clientPromise = createAuth0Client(modOption || getAuth0Options());
	return this.#clientPromise;
}

async handleRedirectCallback() {
		const client = await this.getClient();
		return client.handleRedirectCallback();
	}

	async getUser() {
		const client = await this.getClient();
		return client.getUser();
	}

	async loginWithRedirectOnly({redirectUri,partnerConnection}) {
		const client = await this.getClient();
		return client.loginWithRedirect({
			authorizationParams: {
				...(partnerConnection && {connection: partnerConnection}),
				...(redirectUri && { redirect_uri: redirectUri }),
				audience: REACT_APP_AUTH0_AUDIENCE,
			},
		});
	}

	async loginWithRedirect({email, inviteCode, promptType = "login",connection="email"}) {
		const client = await this.getClient();
		const state = { email, ...(inviteCode && { inviteCode }) };

		return client.loginWithRedirect({
			appState: state,
			authorizationParams: {
				connection,
				login_hint: email,
				prompt: promptType,
				audience: REACT_APP_AUTH0_AUDIENCE,
				scope: "openid profile email offline_access",
			},
		});
	}

	async logout(returnTo=window.location.origin) {
		const client = await this.getClient();
		return client.logout({ logoutParams: { returnTo } });
	}

	async isAuthenticated() {
		const client = await this.getClient();
		return client.isAuthenticated();
	}

	async silentLogin() {
		const client = await this.getClient();
		return client.getTokenSilently({
			authorizationParams: {
				audience: REACT_APP_AUTH0_AUDIENCE,
				scope: "openid profile email offline_access",
			},
		});
	}
}

export const auth0Service = new Auth0Service();
